import { TransitionFn, useTransition } from '@react-spring/web'

import {
  ANIMATION_DISABLED_DURATION,
  CARD_SPRING_TENSION,
} from '../constants/animation'
import { PersonCard, TraitCard } from './useCardPool'

interface CardTransitionStyle {
  transform: string
}

export interface UseCardAnimationResult {
  personTransitions: TransitionFn<PersonCard, CardTransitionStyle>
  traitTransitions: TransitionFn<TraitCard, CardTransitionStyle>
}

export const useCardAnimation = (
  person: PersonCard | null,
  trait: TraitCard | null,
  animationDisabled: boolean,
): UseCardAnimationResult => {
  /**
   * Handle transitions for the person card
   */
  const personTransitions = useTransition(person ? [person] : [], {
    from: {
      transform:
        'rotate(45deg) rotateX(-60deg) rotateY(-90deg) translate(0px, 1000px)',
    },
    enter: {
      transform:
        'rotate(0deg) rotateX(0deg) rotateY(0deg) translate(0px, 0px)',
    },
    leave: {
      transform:
        'rotate(-45deg) rotateX(30deg) rotateY(60deg) translate(0px, -1000px)',
    },
    keys: (person) => person.id,
    config: {
      tension: CARD_SPRING_TENSION,
      duration: animationDisabled ? ANIMATION_DISABLED_DURATION : undefined,
    },
  })

  /**
   * Handle transitions for the trait card
   */
  const traitTransitions = useTransition(trait ? [trait] : [], {
    from: {
      transform:
        'perspective(600px) rotate(-45deg) rotateX(30deg) rotateY(60deg) translate(0px, 1000px)',
    },
    enter: {
      transform:
        'perspective(600px) rotate(0deg) rotateX(0deg) rotateY(0deg) translate(0px, 0px)',
    },
    leave: {
      transform:
        'perspective(600px) rotate(45deg) rotateX(-30deg) rotateY(-60deg) translate(0px, -1000px)',
    },
    keys: (trait) => trait.description,
    config: {
      tension: CARD_SPRING_TENSION,
      duration: animationDisabled ? ANIMATION_DISABLED_DURATION : undefined,
    },
  })

  return { personTransitions, traitTransitions }
}
